// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageLoader_pageLoader__JrnTr {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
}

.PageLoader_text__BT-VT {
  font-family: "Lufga", "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #736b66;
  margin: 0;
}

/* Use inside a flex parent so the block does not force full viewport height */
.PageLoader_embedded__cnRAi {
  min-height: auto;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/PageLoader/PageLoader.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACF;;AAEA,8EAAA;AACA;EACE,gBAAA;EACA,WAAA;AACF","sourcesContent":[".pageLoader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.text {\n  font-family: 'Lufga', 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #736b66;\n  margin: 0;\n}\n\n/* Use inside a flex parent so the block does not force full viewport height */\n.embedded {\n  min-height: auto;\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageLoader": `PageLoader_pageLoader__JrnTr`,
	"text": `PageLoader_text__BT-VT`,
	"embedded": `PageLoader_embedded__cnRAi`
};
export default ___CSS_LOADER_EXPORT___;
